import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=635a4ee4&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=635a4ee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a4ee4",
  null
  
)

export default component.exports